<rt-dialog-header
  class="warning"
  [heading]="'tlc.positions.reassign_member_warning_dialog.header' | translate"
/>

<rt-dialog-body variant="white">
  <span class="description">
    {{ 'tlc.positions.reassign_member_warning_dialog.description' | translate }}
  </span>
  <div class="member-list">
    @for (entry of membersWithFullNames(); track entry.member.guid) {
      <div class="member-item">
        <rt-avatar
          [type]="!!entry.member.avatarThumbUrl ? 'image' : 'initials'"
          [imageSrc]="entry.member.avatarThumbUrl"
          [fullName]="entry.fullName"
          context="admin"
        />
        <div class="member-details">
          <span class="member-name">{{ entry.fullName }}</span>
          <span class="position-name">{{ entry.currentPosition.name }}</span>
        </div>
      </div>
    }
  </div>
  <span
    class="confirmation"
    [innerHTML]="
      'tlc.positions.reassign_member_warning_dialog.confirmation'
        | translate: { position: targetPositionName() }
    "
  ></span>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="warning" (click)="confirm()">
    {{ 'tlc.positions.reassign_member_warning_dialog.confirm_button' | translate }}
  </rt-button>
</rt-dialog-footer>
